import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface ContactHeaderPillProps {
  backgroundColor?: string;
  hoverBackgroundColor?: string;
  textColor?: string;
  className?: string;
  isIconOnly?: boolean;
  isDisabled?: boolean;
}

interface StyledContactHeaderPillContainerDivProps {
  $backgroundColor: string;
  $hoverBackgroundColor: string;
  $textColor: string;
  $isIconOnly?: boolean;
  $isDisabled?: boolean;
}

/*
 * Styles.
 */

const StyledContactHeaderPillContainerDiv = styled.div<StyledContactHeaderPillContainerDivProps>`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: 0 6px;
  border-radius: 10px;
  font-size: ${fontSizes.verySmall};
  line-height: 20px;
  font-weight: ${fontWeights.semibold};

  ${(p) => css`
    background-color: ${p.$backgroundColor};
    color: ${p.$textColor};
  `}
  // Display as a circle with equal padding
  ${(p) =>
    p.$isIconOnly &&
    css`
      padding: 4px;
    `}
  ${(p) =>
    !p.$isDisabled &&
    css`
      &:hover {
        background-color: ${p.$hoverBackgroundColor};
      }
    `}
`;

/*
 * Component.
 */

export const ContactHeaderPill: FC<ContactHeaderPillProps> = (props) => {
  const {textColor, backgroundColor, hoverBackgroundColor, className, isIconOnly, isDisabled} = props;
  const theme = useUserTheme();

  return (
    <StyledContactHeaderPillContainerDiv
      className={className}
      $textColor={textColor || theme.greys.shade80}
      $backgroundColor={backgroundColor || theme.greys.shade10}
      $hoverBackgroundColor={hoverBackgroundColor || theme.greys.shade20}
      $isIconOnly={isIconOnly}
      $isDisabled={isDisabled}
    >
      {props.children}
    </StyledContactHeaderPillContainerDiv>
  );
};
